import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  input,
  output,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';

import { ButtonSeverity } from 'primeng/button';
type ButtonIconPosition = 'left' | 'right' | 'top' | 'bottom';

import { NgTemplateOutlet } from '@angular/common';

import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'prime-button',
  templateUrl: './prime-button.component.html',
  styleUrls: ['./prime-button.component.scss'],
  imports: [ButtonModule, RippleModule, NgTemplateOutlet, AutoFocusModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.p-button-label-normal-weight]': 'hostLabelNormalWeight()',
    '[class.p-button-filter-applied]': 'hostFilterApplied()',
    '[class.p-button-label-truncate]': 'isTruncated()',
    '[class.tw:w-full]': 'fluid()',
  },
})
export class PrimeButtonComponent {
  readonly type = input('button');
  readonly iconPos = input<ButtonIconPosition>('left');
  readonly icon = input<string>();
  readonly badge = input<string>();
  readonly label = input<string>();
  readonly disabled = input<boolean>();
  readonly loading = input(false);
  readonly rounded = input(false);
  readonly text = input(false);
  readonly severity = input<ButtonSeverity>();
  readonly outlined = input(false);
  readonly link = input(false);
  readonly size = input<'small' | 'large'>();
  readonly variant = input<'outlined' | 'text'>();
  readonly style = input<Record<string, unknown> | null>();
  readonly styleClass = input<string>();
  readonly badgeSeverity = input<'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' | null | undefined>(
    'secondary',
  );
  readonly ariaLabel = input<string>();
  readonly ariaCurrent = input<'page' | 'step' | 'location' | 'date' | 'time' | boolean>();
  readonly ariaPressed = input<boolean | 'mixed'>();
  readonly autofocus = input<boolean>();
  readonly fluid = input<boolean>();
  readonly onClick = output<MouseEvent>();

  readonly isLabelNormalWeight = input(false);
  readonly isButtonAsFilterApplied = input(false);
  readonly pAutoFocus = input(false);
  readonly isHighlighted = input<boolean>(false);
  readonly isTruncated = input<boolean>(false);
  readonly iconTemplate = contentChild<TemplateRef<null> | null>('iconTemplate');
  readonly contentTemplate = contentChild<TemplateRef<null> | null>('contentTemplate');

  hostLabelNormalWeight = computed(() => {
    return this.isLabelNormalWeight();
  });
  hostFilterApplied = computed(() => {
    return this.isButtonAsFilterApplied();
  });
}
